import React from 'react';
import UpworkFeedSwitcher from './UpworkFeedSwitcher';

/**
 * 3-column responsive layout for Job Board
 * Desktop: Left sidebar (filters) | Center (jobs) | Right sidebar (profile/stats)
 * Tablet: Collapsed left | Center | Right
 * Mobile: Single column
 */
const JobBoardLayout = ({
  leftSidebar,
  children,
  rightSidebar,
  className = ''
}) => {
  return (
    <div className={`bg-slate-50 ${className}`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Left Sidebar - Filters (Desktop only) */}
          {leftSidebar && (
            <aside className="hidden lg:block w-60 flex-shrink-0">
              <div className="sticky top-20">
                {leftSidebar}
              </div>
            </aside>
          )}

          {/* Main Content - Job List */}
          <main className="flex-1 min-w-0">
            <UpworkFeedSwitcher>{children}</UpworkFeedSwitcher>
          </main>

          {/* Right Sidebar - Profile & Stats */}
          {rightSidebar && (
            <aside className="hidden xl:block w-80 flex-shrink-0">
              <div className="sticky top-20 space-y-4">
                {rightSidebar}
              </div>
            </aside>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobBoardLayout;
